import { ListboxItem } from '@groundworks/ngx-groundworks-ui';
import { PendingSaleInfo } from '../sdk/sdk';

export function removeListboxItemById(list: ListboxItem[], id: string): boolean {
  const index = list.findIndex(item => item.id === id);
  if (index === -1) {
    return false;
  }

  list.splice(index, 1);
  return true;
}

export function mapPendingSaleToListboxItem(sale: PendingSaleInfo, appBaseUrl: string): ListboxItem {
  return {
    id: sale.id,
    branch: sale.branch,
    name: sale.customerName,
    appointmentType: sale.appointmentType,
    saleDate: sale.saleDate,
    saleAmount: sale.saleAmount,
    cfiName: sale.cfiName,
    action: `${appBaseUrl}/pending-sale?opportunityId=${sale.id}`,
  };
}
